// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var withHandlers = require('recompose').withHandlers;
  var FontSettingsPopup = require('share/components/controls/CommonPopup/Izenda.FontSettingsPopup');
  const { curry } = require('lodash/fp');
  /**
   * Save font settings and close fonts popup
   * @param settings
   */
  var save = function(props, settings) {
    var dashboardPart = props.dashboardPart;
    var fn = props.dataKey === 'contentTitle' ? 'updateContentTitleSettings' : 'updateContentDescriptionSettings';

    dashboardPart[fn] && dashboardPart[fn](settings);
  };

  /**
   * Toggle font settings popup
   */
  var openPopup = function(props) {
    return function() {
      var dataKey = props.dataKey;
      var dashboardPart = props.dashboardPart;

      function getFontSettings() {
        return dashboardPart[dataKey].settings;
      }

      props.openPopup(FontSettingsPopup, {
        title: props.title,
        font: getFontSettings(),
        save: curry(save)(props)
      });
    };
  };

  module.exports = withHandlers({
    openPopup: openPopup
  });
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.TileTitleBackSideAction.js